<ol *ngIf="items.length" #mainBreadcrumb itemscope itemtype="https://schema.org/BreadcrumbList" class="mainBreadcrumb">
  <ng-container *ngFor="let item of items; let i = index; let lastItem = last">
    <li
      itemprop="itemListElement"
      itemtype="https://schema.org/ListItem"
      itemscope
      *ngIf="item.localizedName"
      class="mainBreadcrumb__item"
      [ngClass]="{'mainBreadcrumb__item--notActive': isActiveItem(item.url.path)}"
    >
      <vc-ref *ngIf="!isActiveItem(item.url.path) && !lastItem" microData="item" resource="{{ item.url.path }}">
        <span itemprop="name">
          <ng-container *ngTemplateOutlet="contentItem"></ng-container>
        </span>
      </vc-ref>
      <h1 class="mainBreadcrumb__h1" itemprop="name" *ngIf="isCatalogPage && lastItem">
        <ng-container *ngTemplateOutlet="contentItem"></ng-container>
      </h1>
      <span *ngIf="lastItem && !isCatalogPage" itemprop="name">
        <ng-container *ngTemplateOutlet="contentItem"></ng-container>
      </span>
      <meta *ngIf="lastItem" itemprop="item" [content]="completeUrl" /> <meta itemprop="position" [content]="i + 1" />
    </li>
    <ng-template #contentItem>
      {{ item.localizedName }}
    </ng-template>
  </ng-container>
</ol>
